<template>
  <el-dialog :title="'设置排班 - ' + technician.name" :visible.sync="dialogVisible" :close-on-click-modal="false"
             :close-on-press-escape="false" @close="dialogFormVisible" width="800px">
    <el-form v-loading="loading">
      <div v-for="(day, index) in form.schedule_list" :key="index" class="schedule-day-row">
        <span class="day-label">星期{{ weekDays[day.day_of_week - 1] }}</span>
        <el-switch v-model="day.is_active" :active-value="1" :inactive-value="0"></el-switch>
        <div class="time-picker-group" v-if="day.is_active === 1">
          <el-time-picker is-range v-model="day.work_time_range" range-separator="至" start-placeholder="上班时间"
                          end-placeholder="下班时间" value-format="HH:mm:ss">
          </el-time-picker>
          <div class="break-time-section">
            <div v-if="!day.show_break_time" class="add-break-time">
              <el-button type="text" @click="showBreakTime(index)" class="add-break-btn">
                <i class="el-icon-plus"></i>
                添加休息时间
              </el-button>
            </div>
            <div v-else class="break-time-picker">
              <el-time-picker is-range v-model="day.break_time_range" range-separator="至" start-placeholder="休息开始"
                              end-placeholder="休息结束" value-format="HH:mm:ss">
              </el-time-picker>
              <el-button type="text" @click="hideBreakTime(index)" class="remove-break-btn">
                <i class="el-icon-close"></i>
                移除休息时间
              </el-button>
            </div>
          </div>
        </div>
        <span v-else class="rest-text">休息</span>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submitClick" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ScheduleApi from '@/api/technician/schedule.js';

export default {
  name: 'TechnicianSchedule',
  props: ['open_schedule', 'technician'],
  data() {
    return {
      loading: true,
      dialogVisible: false,
      weekDays: ['一', '二', '三', '四', '五', '六', '日'],
      form: {
        technician_id: 0,
        schedule_list: [] // 存放7天排班对象的数组
      }
    };
  },
  created() {
    this.dialogVisible = this.open_schedule;
    this.form.technician_id = this.technician.id;
    this.getScheduleData();
  },
  methods: {
    // 获取技师的排班数据
    getScheduleData() {
      let self = this;
      self.loading = true;
      ScheduleApi.getScheduleByTechnicianId({ technician_id: self.technician.id }, true)
        .then(res => {
          if (res.code === 1) {
            self.initScheduleForm(res.data.week_schedule);
          }
          self.loading = false;
        })
        .catch(() => {
          self.loading = false;
        });
    },

    // 初始化表单数据，确保7天都有
    initScheduleForm(apiData) {
      const scheduleMap = new Map();
      if (apiData) {
        apiData.forEach(item => scheduleMap.set(item.day_of_week, item));
      }

      this.form.schedule_list = [];
      for (let i = 1; i <= 7; i++) {
        const schedule = scheduleMap.get(i) || {};
        this.form.schedule_list.push({
          day_of_week: i,
          is_active: schedule.is_active !== undefined ? schedule.is_active : 0,
          start_time: schedule.start_time || '09:00:00',
          end_time: schedule.end_time || '18:00:00',
          break_start_time: schedule.break_start_time || null,
          break_end_time: schedule.break_end_time || null,
          // 用于el-time-picker的辅助字段
          work_time_range: [schedule.start_time || '09:00:00', schedule.end_time || '18:00:00'],
          break_time_range: schedule.break_start_time ? [schedule.break_start_time, schedule.break_end_time] : null,
          show_break_time: schedule.break_start_time ? true : false // 只有当有休息时间数据时才显示
        });
      }
    },

    // 提交数据
    submitClick() {
      let self = this;
      self.loading = true;

      // 提交前，将辅助字段的值赋给真实字段
      self.form.schedule_list.forEach(day => {
        if(day.is_active === 1 && day.work_time_range){
          day.start_time = day.work_time_range[0];
          day.end_time = day.work_time_range[1];
        }
        if(day.is_active === 1 && day.show_break_time && day.break_time_range){
          day.break_start_time = day.break_time_range[0];
          day.break_end_time = day.break_time_range[1];
        } else {
          day.break_start_time = null;
          day.break_end_time = null;
        }
      });

      // 准备提交的数据，移除辅助字段
      const params = {
        technician_id: self.form.technician_id,
        schedule_list: self.form.schedule_list.map(({ work_time_range, break_time_range, show_break_time, ...rest }) => rest)
      };

      ScheduleApi.batchSet(params, true)
        .then((res) => {
          self.loading = false;
          if (res.code === 1) {
            self.$message.success('保存成功');
            self.dialogFormVisible(true);
          }
        })
        .catch(() => {
          self.loading = false;
        });
    },

    // 关闭弹窗
    dialogFormVisible(isSuccess) {
      this.$emit('closeDialog', { type: isSuccess ? 'success' : 'cancel' });
    },

    // 显示休息时间选择器
    showBreakTime(index) {
      this.$set(this.form.schedule_list[index], 'show_break_time', true);
    },

         // 隐藏休息时间选择器
     hideBreakTime(index) {
       this.$set(this.form.schedule_list[index], 'show_break_time', false);
       this.$set(this.form.schedule_list[index], 'break_time_range', null);
     }
  }
};
</script>

<style scoped>
.schedule-day-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.day-label {
  width: 80px;
  font-weight: bold;
}
.time-picker-group {
  margin-left: 20px;
}
.time-picker-group > :nth-child(2) {
  margin-top: 5px;
}
.rest-text {
  margin-left: 20px;
  color: #999;
}
.break-time-section {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.add-break-time {
  margin-left: 20px;
}
.add-break-btn {
  color: #409EFF;
}
.break-time-picker {
  display: flex;
  align-items: center;
  /*margin-left: 20px;*/
}
.break-time-picker .el-time-picker {
  width: 150px; /* Adjust as needed */
}
.remove-break-btn {
  margin-left: 10px;
  color: #F56C6C;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/schedule/Edit.vue